import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { LiveChatWidget } from './components/LiveChatWidget';
import { HomePage } from './pages/HomePage';
import { ServicesPage } from './pages/ServicesPage';
import { PortfolioPage } from './pages/PortfolioPage';
import { ContractsPage } from './pages/ContractsPage';
import { BlogPage } from './pages/BlogPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { CostCalculatorPage } from './pages/CostCalculatorPage';
import { CustomerPortalPage } from './pages/CustomerPortalPage';
import { HouseClearancePage } from './pages/service/HouseClearancePage';
import { OfficeRemovalsPage } from './pages/service/OfficeRemovalsPage';
import { CommercialWastePage } from './pages/service/CommercialWastePage';
import { GardenWastePage } from './pages/service/GardenWastePage';
import { OverseasRemovalsPage } from './pages/service/OverseasRemovalsPage';
import { EstateAgentPage } from './pages/service/EstateAgentPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="flex flex-col min-h-screen" data-id="element-1">
        <Header data-id="element-2" />
        <main className="flex-1" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
            <Route path="/services" element={<ServicesPage data-id="element-8" />} data-id="element-7" />
            <Route path="/portfolio" element={<PortfolioPage data-id="element-10" />} data-id="element-9" />
            <Route path="/contracts" element={<ContractsPage data-id="element-12" />} data-id="element-11" />
            <Route path="/blog" element={<BlogPage data-id="element-14" />} data-id="element-13" />
            <Route path="/about" element={<AboutPage data-id="element-16" />} data-id="element-15" />
            <Route path="/contact" element={<ContactPage data-id="element-18" />} data-id="element-17" />
            <Route path="/calculator" element={<CostCalculatorPage data-id="element-20" />} data-id="element-19" />
            <Route path="/portal" element={<CustomerPortalPage data-id="element-22" />} data-id="element-21" />
            <Route path="/services/house-clearance" element={<HouseClearancePage data-id="element-24" />} data-id="element-23" />
            <Route path="/services/office-removals" element={<OfficeRemovalsPage data-id="element-26" />} data-id="element-25" />
            <Route path="/services/commercial-waste" element={<CommercialWastePage data-id="element-28" />} data-id="element-27" />
            <Route path="/services/garden-waste" element={<GardenWastePage data-id="element-30" />} data-id="element-29" />
            <Route path="/services/overseas-removals" element={<OverseasRemovalsPage data-id="element-32" />} data-id="element-31" />
            <Route path="/services/estate-agent" element={<EstateAgentPage data-id="element-34" />} data-id="element-33" />
          </Routes>
        </main>
        <Footer data-id="element-35" />
        <LiveChatWidget data-id="element-36" />
      </div>
    </BrowserRouter>;
}